import React from 'react';
import PageTemplate from '@/components/ui/PageTemplate';
import { RESOURCE_CONTEXT } from '@/constants/context';
import ResourceList from '@/components/resource/ResourceList';
import useObserver from '@/hooks/page/useObserver';

const Resources = () => {
  useObserver('content-Resources', 'content-Resources-tablet', 'content-Resources-desktop');

  return (
    <PageTemplate id='Resources'>
      {/* Mobile Layout */}
      <div
        id='content-Resources'
        className='md:hidden w-full min-h-screen bg-cover bg-center bg-no-repeat relative'
        style={{ backgroundImage: "url('/redesign/BG_Resources.png')" }}
      >
        <div className='w-full max-w-[360px] mx-auto py-20 flex flex-col gap-10'>
        <div className='flex flex-col justify-start items-start w-full px-4'>
          <h1 className='text-[20px] font-semibold text-[#FFFFFF]'>Resources</h1>
        </div>
        <div className='w-full flex flex-col gap-6 px-4'>
          <div className='w-full flex flex-col justify-center items-start'>
            <h1 className='text-[20px] font-semibold text-white'>
              <p>We are pioneering Space-Time</p>
              <p>AI technology fused with</p>
              <p>the Voronoi diagram</p>
              <p>in the space industry.</p>
            </h1>
          </div>
          <div className='w-full flex flex-col justify-center gap-2'>
            {RESOURCE_CONTEXT.DESCRIPTION.map((item, index) => {
              return (
                <article key={index} className='text-white text-sm font-light'>
                  {item}
                </article>
              );
            })}
          </div>
          <div className='w-full flex justify-start items-center'>
            <ResourceList />
          </div>
        </div>
        </div>
      </div>

      {/* Tablet Layout */}
      <div
        id='content-Resources-tablet'
        className='hidden md:flex xl:hidden w-full min-h-full -mt-20 relative'
      >
        <div className='w-full max-w-[688px] mx-auto flex flex-col py-36 gap-24'>
        <div className='flex flex-col justify-start items-start w-full'>
          <h1 className='text-[30px] font-semibold text-[#FFFFFF]'>Resources</h1>
        </div>
        <div className='relative z-20 flex flex-row gap-6'>
          <div className='h-full flex flex-col gap-10'>
            <div className='w-full flex flex-col justify-center items-start'>
              <h1 className='text-4xl font-semibold text-white whitespace-nowrap'>
                <p>We are pioneering</p>
                <p>Space-Time AI</p>
                <p> technology </p>
                <p>fused with the</p>
                <p>Voronoi diagram</p>
                <p>in the space</p>
                <p>industry</p>
              </h1>
            </div>
            <div className='w-full flex flex-col justify-center gap-8'>
              {RESOURCE_CONTEXT.DESCRIPTION.map((item, index) => {
                return (
                  <article
                    key={index}
                    className='text-white text-lg font-medium'
                  >
                    {item}
                  </article>
                );
              })}
            </div>
          </div>
          <div className='w-1/2 flex flex-col justify-start items-center'>
            <ResourceList />
          </div>
        </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div
        id='content-Resources-desktop'
        className='hidden xl:flex w-full min-h-full -mt-20 relative'
      >
        <div className='w-full max-w-[1060px] mx-auto flex flex-col py-36 gap-24'>
        <div className='flex flex-col justify-start items-start w-full'>
          <h1 className='text-2xl font-semibold text-[#FFFFFF]'>Resources</h1>
        </div>
        <div className='relative z-20 flex flex-row gap-16'>
          <div className='w-1/2 h-full flex flex-col gap-10'>
            <div className='w-full flex flex-col justify-center items-start'>
              <h1 className='text-[32px] font-semibold text-white'>
                <p>We are pioneering</p>
                <p>Space-Time AI technology</p>
                <p>fused with the</p>
                <p>Voronoi diagram in the</p>
                <p>space industry</p>
              </h1>
            </div>
            <div className='w-full flex flex-col justify-center gap-8'>
              {RESOURCE_CONTEXT.DESCRIPTION.map((item, index) => {
                return (
                  <article
                    key={index}
                    className='text-white text-lg font-medium'
                  >
                    {item}
                  </article>
                );
              })}
            </div>
          </div>
          <div className='w-1/2 flex flex-col justify-start items-center'>
            <ResourceList />
          </div>
        </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default React.memo(Resources);
